import React, { memo, useCallback } from 'react';
import { Ellipse } from '@yme/assets/icons';
import { SVGIcon, ICON_SIZE } from '@yme/atoms/svg-icon';
import { buildKey } from '@yme/utils/common';
import { keyCodes } from '@yme/utils/constants';
import { BIG_SIZE } from './constants';
import { ColorSelectorStyled, SVGIconStyled } from './styled';
/**
 * Atom - Color Selector
 *
 * @param sizeType - two options: SMALL_SIZE, BIG_SIZE
 * @param data - ReadonlyArray<IItemColorProps>
 * @param activeItemColorIndex - any number (from 0 and etc)
 * @param onClick - (index: number) => void;
 * @param isRightToLeft - boolean (default - false)
 *
 * @returns ReactElement
 */
function ColorSelectorComponent({ sizeType = BIG_SIZE, data, activeItemColorIndex, onClick, isRightToLeft = false, }) {
    const isSelectorBigSize = sizeType === BIG_SIZE;
    const size = isSelectorBigSize ? ICON_SIZE.s : ICON_SIZE.xxs;
    const paddingSize = isSelectorBigSize ? 5 : 3;
    const onClickHandler = useCallback((index, colourId) => {
        onClick(index, colourId);
    }, [onClick]);
    const keyDownHandler = useCallback((event, index, colourId) => {
        if (event.key === keyCodes.ENTER) {
            onClickHandler(index, colourId);
        }
    }, [onClickHandler]);
    return (React.createElement(ColorSelectorStyled, { paddingSize: paddingSize, isSelectorBigSize: isSelectorBigSize }, data.map(({ colourName, colourCode, colourId }, index) => {
        const isActive = index === activeItemColorIndex;
        const key = buildKey('item-color', colourId);
        const dataTestIdKey = buildKey('item-color', colourId);
        return (React.createElement("div", { key: key, "data-testid": dataTestIdKey },
            React.createElement(SVGIconStyled, { colourCode: colourCode, isActive: isActive, onClick: () => !isActive && onClickHandler(index, colourId), size: size, isRightToLeft: isRightToLeft, paddingSize: paddingSize, isSelectorBigSize: isSelectorBigSize, role: "button", tabIndex: 0, onKeyDown: (event) => keyDownHandler(event, index, colourId) },
                React.createElement(SVGIcon, { type: Ellipse, size: size, rectFill: colourCode, title: colourName }))));
    })));
}
export const ColorSelector = memo(ColorSelectorComponent);
ColorSelector.displayName = 'ColorSelector_Component';
